import { useEffect, useState } from 'react'
import { Avatar } from '@mui/material'
import { useAuthContext } from '../../contexts/auth'
import BaseService from '../../services/base-service'

export const FotoUsuario = () => {
  const { user } = useAuthContext()

  const [foto, setFoto] = useState<string | null>(null)

  useEffect(() => {
    (async () => {
      const url = user?.foto
      if (url) {
        try {
          const client = new BaseService<any>()
          await client
            .getBlob(url)
            .then((response) => {
              const imageBlob = response.data
              if (imageBlob && imageBlob.size > 0) {
                const imageObjectUrl = URL.createObjectURL(imageBlob)
                setFoto(imageObjectUrl)
              } else {
                setFoto(null)
              }
            })
            .catch((error) => {
              // Silenciar erros de CORS ou rede - usar avatar padrão
              if (error.code === 'ERR_NETWORK' || error.message?.includes('CORS') || error.message?.includes('Network Error')) {
                // Erro de CORS/Network - silenciar e usar avatar padrão
                setFoto(null)
              } else {
                // Outros erros podem ser logados se necessário
                setFoto(null)
              }
            })
        } catch (error: any) {
          // Silenciar erros de CORS ou rede
          if (error?.code === 'ERR_NETWORK' || error?.message?.includes('CORS') || error?.message?.includes('Network Error')) {
            setFoto(null)
          } else {
            setFoto(null)
          }
        }
      } else {
        setFoto(null)
      }
    })()
    // Cleanup function to revoke object URL
    return () => {
      if (foto) {
        URL.revokeObjectURL(foto)
      }
    }
  }, [user?.foto])

  return foto ? (
    <Avatar alt={user?.name} src={foto} sx={{ width: 32, height: 32 }} />
  ) : (
    <Avatar alt={user?.name} sx={{ width: 32, height: 32 }} />
  )
}
